var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticStyle:{"font-size":"4rem"}},[_vm._v(_vm._s(_vm.timerStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }